import React from 'react';
import { T_OrderProduct, useCouponStore } from '@sky-tv-group/shared';
import { T_Coupon, BillingCampaign } from '@sky-tv-group/shared/src/types';
import { CheckCircle } from './RunningTotalIcons';

interface RunningTotalOfferProps {
  offer: T_OrderProduct | undefined;
  coupon: T_Coupon | undefined;
  offerText?: string;
  campaign?: BillingCampaign;
  captionless?: boolean;
  additionalClasses?: string;
  showNew?: boolean;
}
const RunningTotalOffer = ({
  offer,
  coupon,
  offerText,
  campaign,
  captionless,
  additionalClasses,
  showNew = false,
}: RunningTotalOfferProps) => {
  const { voucher,eligibilityOffers } = useCouponStore();
  const couponCode=coupon?.couponCode??'';
  const eligibilityExcludeCampaigns=eligibilityOffers?.eligibilityExcludeCampaign?.split(',') ?? [];
  const isEligibilityExcludeOffer= eligibilityExcludeCampaigns.includes(couponCode)
  const isVoucherCoupon = voucher?.coupon?.includes(coupon?.couponCode as string);
  return (
    <>
      {!isVoucherCoupon && (
        
        <p
          className={`${isEligibilityExcludeOffer? 'line-through decoration-secondary-red' : ''
                      } pb-2 items-center justify-between max-w-80%  ${
            additionalClasses ? additionalClasses : 'text-primary-mid-night'
          }
        ${showNew ? 'sky-h6-reg' : 'sky-h7-reg'}`}
          data-testid={`running-total-offer-${coupon?.couponCode}`}>
          <span className="flex items-center">
            <span
              className="icon-wrapper mr-3"
              style={{
                minWidth: '15px',
                width: '15px',
                height: '15px',
                display: 'inline-block',
                cursor: 'pointer',
                color: '#9100D4',
              }}>
              <CheckCircle />
            </span>
            {campaign ? (
              <span>Offer {campaign.promotionCode} applied</span>
            ) : offer ? (
              offer.product.name
            ) : coupon ? (
              coupon.name
            ) : (
              ''
            )}
          </span>
          {!captionless && (
            
            <span
              className={`${showNew ? 'sky-h7-reg' : 'sky-sub'} inline-block pl-7 ${isEligibilityExcludeOffer? 'line-through decoration-secondary-red' : ''
                      }`}
              dangerouslySetInnerHTML={{ __html: offer ? offer.promotionTitle : offerText ?? '' }}></span>
             
          )}
        </p>
        
      )}
    </>
  );
};

export { RunningTotalOffer };
